import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useMemo } from 'react'

import { Localized } from '../../../../localization/react'
import { ScheduleSession } from '../../ActivityDetails.types'
import ContentWrapper from '../../components/ContentWrapper'

import { sortSessions } from './helpers/sort-sessions'
import ScheduleCards from './ScheduleCards'
import ScheduleTable from './ScheduleTable'

interface Props {
  eventSessions: Array<ScheduleSession>
}

const Schedule = ({ eventSessions }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const sortedSessions = useMemo(() => sortSessions(eventSessions), [eventSessions])

  return (
    <ContentWrapper>
      <Stack gap={1}>
        <Heading is="h2" color="midnight">
          <Localized id="activity-detail-schedule-heading" />
        </Heading>
        <Text color="carbon" variant="small">
          <Localized id="activity-detail-schedule-subheading" />
        </Text>
      </Stack>
      {isMobile ? (
        <ScheduleCards sessions={sortedSessions} />
      ) : (
        <div style={{ minWidth: '340px' }}>
          <ScheduleTable sessions={sortedSessions} />
        </div>
      )}
    </ContentWrapper>
  )
}

export default Schedule
